module.exports = __webpack_public_path__ + "entry-150bfe9b/basf-photo-9e1f8c956c7a7a42b3b39913e828ea56.webp";